import { createSlice } from "@reduxjs/toolkit";
import { getTasks } from "../reduxApi/taskReduxApi";

const taskSlice = createSlice({
    name: 'tasks',
    initialState: {
        status: 'idel',
        isFiltered: false,
        tasks: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteTaskAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.tasks.findIndex((item) => item.tasks.ROWID === id);
                if (index !== -1) {
                    state.tasks.splice(index, 1);
                }
            });
        },
        updateTaskAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.tasks.findIndex((item) => item.tasks.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.tasks.splice(index, 1, { tasks: action.payload })
            }
        },
        addTaskAction: (state, action) => {
            console.log("Adding tasks:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.tasks.unshift({ tasks: temp });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTasks.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getTasks.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing tasks Data", action.payload)
                state.tasks = action.payload.data.taskResp
                    ;
            })
    }
})
export const { deleteTaskAction, updateTaskAction, addTaskAction,setFilteredStatus } = taskSlice.actions
export default taskSlice.reducer